export default {
  computed: {
    reshipOnly() {
      return (
        "discountedUnitPrice" in this.shopifyLineItem &&
        Number(this.shopifyLineItem.discountedUnitPrice) === 0
      );
    },
    reshipOnlyText() {
      return "$0 item. Eligible for reship only.";
    }
  }
};
